import React, { ReactElement } from "react";
import { IBaseTag } from "@common/redux/types/tags";
import styles from "./Tags.module.scss";
import classnames from "classnames";
import { Tag } from "@kursk/components/ui/Tag/Tag";
import { useDispatch } from "react-redux";
import { push } from "connected-next-router";

interface IProps {
  tags: IBaseTag[];
  link?: string;
  isGenre?: boolean;
  className?: string;
}

export const Tags = ({ tags, link, isGenre = false, className }: IProps): ReactElement => {
  const dispatch = useDispatch();

  if (!tags || tags.length === 0) return <></>;
  return (
    <div className={classnames(styles.wrapper, className && className)}>
      {
        tags.map((tag: IBaseTag) => (
          <Tag
            key={tag._id}
            tag={tag}
            onClick={link ? () => dispatch(push(`${link}/${isGenre ? 'genre' : 'tag'}-${tag.sysName}`)) : null}
          />
        ))
      }
    </div>
  )
}
